"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TemplateDataExtender {
    constructor(templateData) {
        this.templateData = templateData;
    }
    getData() {
        return this.templateData;
    }
    async addLocaleInfoForCompany(company) {
        const localeInfo = await company.getLocaleInfo();
        this.templateData = {
            ...this.templateData,
            ...localeInfo,
        };
    }
    async addLinkedRecordTemplateData(message, existingTemplateData = {}) {
        this.templateData = {
            ...this.templateData,
            ...await message.getLinkedRecordTemplateData(existingTemplateData),
        };
    }
}
exports.default = TemplateDataExtender;
//# sourceMappingURL=../../../src/utilities/templateDataExtender.js.map